import { ChangeDetectionStrategy, Component, inject, input, InputSignal, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ToastService } from '@core/services/toast/toast.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { IconModule } from "@ogs-gmbh/ngx-m3-components";
import { STATUS_TYPES, StatusType } from '@shared/types/status.types';
@Component({
  selector: 'app-toast',
  imports: [ MatButtonModule, IconModule ],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ToastComponent implements OnInit {
  private _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  private _toastService: ToastService = inject(ToastService);

  public id: InputSignal<string> = input.required();

  public status: InputSignal<StatusType> = input<StatusType>(STATUS_TYPES.neutral);

  protected statusTypes: typeof STATUS_TYPES = STATUS_TYPES;


  public ngOnInit (): void {
    this._faIconLibrary.addIcons(faXmark);
  }

  protected onCloseClick (): void {
    this._toastService.close(this.id());
  }
}
